module.exports = __webpack_public_path__ + "static/img/Homev2.ca81404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/Homev2.png
// module id = GeOB
// module chunks = 36